import styled, { css } from 'styled-components';

const theme = {
  fontFamily: 'Roboto',
  color: {
    primary: {
      default: '#007db8',
      hover: '#006493',
      outlined: '#b3d8ea',
    },
    secondary: {
      default: '#41b6e6',
      hover: '#0F1E30',
      outlined: '#d3f2ff',
    },
    warning: {
      default: '#f2af00',
      hover: '#c28c00',
      outlined: '#fbe7b3',
    },
    success: {
      default: '#7ab800',
      hover: '#629300',
      outlined: '#dcfbb3',
    },
    grey: {
      default: '#ababab',
      hover: '#41b6e6',
      outlined: '#ababab',
    },
    error: {
      default: '#ce1126',
      hover: '#a50e1e',
      outlined: '#ce1126',
    },
  },
  size: {
    xs: {
      font: {
        primary: '12px',
        secondary: '10px',
      },
      padding: '2px 6px',
      dimensions: '25px',
    },
    sm: {
      font: {
        primary: '14px',
        secondary: '10px',
      },
      padding: '5px 20px',
      dimensions: '40px',
    },
    md: {
      font: {
        primary: '16px',
        secondary: '12px',
      },
      padding: '10px 30px',
      dimensions: '60px',
    },
    lg: {
      font: {
        primary: '20px',
        secondary: '12px',
      },
      padding: '23px 40px',
      dimensions: '80px',
    },
    xl: {
      font: {
        primary: '35px',
        secondary: '18px',
      },
      padding: '45px 65px',
      dimensions: '120px',
    },
    xxl: {
      font: {
        primary: '60px',
        secondary: '30px',
      },
      padding: '65px 85px',
      dimensions: '160px',
    },
  },
  borderRadius: '2px',
  screenSize: {
    xxs: '320px',
    xs: '576px',
    sm: '768px',
    md: '992px',
    lg: '1200px',
  },
};

const MenuBox = styled.div`
  position: fixed;
  top: 0;
  height: 100%;
  display: flex;
  background-color: ${props => props.backgroundColor};
  z-index: 9999;
  box-shadow: -8px 0 10px 10px rgba(0, 0, 0, 0.2);
  transition: transform 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  width: 100%;
  @media (min-width: ${theme.screenSize.xs}) {
    width: ${props => props.width};
  }

  ${props => (props.visible ? SlideAnimation : '')}
  ${props => (props.direction === 'left' ? LeftMenuBox : RightMenuBox)}
`;

const LeftMenuBox = css`
  left: 0;
  transform: translateX(${props => (props.visible ? '0' : '-100%')});
  /* @media (min-width: ${theme.screenSize.xs}) {
    transform: translateX(${props => (props.visible ? '0' : '-100%')});
    width: 66%;
  } */
`;

const RightMenuBox = css`
  right: 0;
  transform: translateX(${props => (props.visible ? '0' : '100%')});
  /* @media (min-width: ${theme.screenSize.xs}) {
    transform: translateX(${props => (props.visible ? '0' : '100%')});
    width: 66%;
  } */
`;

const SlideAnimation = css`
  -webkit-animation: slideIn 0.4s;
  animation: slideIn 0.4s;

  @-webkit-keyframes slideIn {
    from {
      transform: translateX(${props => (props.direction === 'left' ? '-100%' : '100%')});
    }
    to {
      transform: translateX(0);
    }
  }
  @keyframes slideIn {
    from {
      transform: translateX(${props => (props.direction === 'left' ? '-100%' : '100%')});
    }
    to {
      transform: translateX(0);
    }
  }
`;

const MenuWrapper = styled.div`
  color: #fff;
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: flex-start;
`;

const MenuHeader = styled.div`
  display: flex;
  align-items: center;
`;

const MenuNav = styled.div``;

const MenuList = styled.ul`
  list-style: none;
  color: #fff;
  margin: 20px 0 0 20px;
  padding-left: 0;

  @media (min-width: ${theme.screenSize.xs}) {
    margin: 30px 0 0 30px;
  }
`;

const MenuListItem = styled.li`
  margin: 5px 0;

  &:first-child {
    margin: 0 0 5px;
  }

  &:last-child {
    display: block;
    @media (min-width: ${theme.screenSize.xs}) {
      display: none;
    }
  }
`;

const MenuListLink = styled.a`
  color: #fff;
  text-decoration: none;
  font-size: 18px;
  font-weight: 500;
  line-height: 40px;
  @media (min-width: ${theme.screenSize.xs}) {
    font-size: 20px;
  }
`;

const CloseButton = styled.div`
  padding: 15px 10px 17px 20px;
  cursor: pointer;
  margin-right: 10px;
  @media (min-width: ${theme.screenSize.xs}) {
    padding: 21px 15px 22px 30px;
  }

  svg {
    fill: #fff;
    width: 16px;
    height: 16px;
  }
`;

const UserImage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #dadada;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  font-size: 22px;
`;

const Actions = styled.div`
  margin-left: 10px;
`;

const ProfileLink = styled.a`
  font-size: 16px;
  font-weight: 300;
  text-decoration: none;
  color: #fff;
  @media (min-width: ${theme.screenSize.xs}) {
    font-size: 18px;
  }
`;

const SignOut = styled.a`
  display: none;
  font-size: 13px;
  font-weight: 500;
  text-decoration: none;
  color: #fff;
  @media (min-width: ${theme.screenSize.xs}) {
    display: block;
  }
`;

export {
  MenuBox,
  MenuWrapper,
  MenuHeader,
  MenuNav,
  MenuList,
  MenuListItem,
  MenuListLink,
  CloseButton,
  UserImage,
  Actions,
  ProfileLink,
  SignOut,
};
